export var DidNotGetInsiderFreeDutiesIA = function DidNotGetInsiderFreeDutiesIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    }
  };
};
var getAnswer = function getAnswer(_context, strictLocalize) {
  return {
    getTitle: function getTitle() {
      return WHY_I_DID_NOT_RECEIVE_FREE_DUTIES(strictLocalize);
    },
    getDescription: function getDescription() {
      return [INSIDER_OFFERS_FREE_DUTIES_WITH_SELECT_BRANDS(strictLocalize)];
    }
  };
};
var WHY_I_DID_NOT_RECEIVE_FREE_DUTIES = function WHY_I_DID_NOT_RECEIVE_FREE_DUTIES(strictLocalize) {
  return strictLocalize({
    id: "/eaC3R",
    defaultMessage: [{
      "type": 0,
      "value": "Pourquoi n'ai-je pas bénéficié des droits de douane gratuits sur ma commande ?"
    }]
  });
};
var INSIDER_OFFERS_FREE_DUTIES_WITH_SELECT_BRANDS = function INSIDER_OFFERS_FREE_DUTIES_WITH_SELECT_BRANDS(strictLocalize) {
  return strictLocalize({
    id: "Kl7yLn",
    defaultMessage: [{
      "type": 0,
      "value": "Il est important de savoir que votre abonnement Insider offre les droits de douane gratuits pour certaines marques. Bien que cet avantage ne s'applique pas à l'ensemble de la plateforme, vous pouvez facilement identifier les marques proposant cette option sur Faire. Il vous suffit de rechercher les marques portant la mention « Livraison et droits de douane gratuits avec Insider » ainsi qu'une clé bleue. De plus, il vous sera indiqué lors du passage en caisse si votre abonnement Insider prend en charge les droits de douane pour une marque spécifique."
    }]
  });
};